jQuery(function($){

    // Click on search icon
    $('#search-trigger').on('click', function(){
        if( this.classList.contains('is-open') ){
            return close_search();
        }
        return open_search();
    })

    // Click on cross icon (close search)
    $('#close-search').on('click', close_search );

    // Function that opens the searchform
    function open_search(){
        $('#search-trigger').addClass('is-open');
        $('#searchform').fadeIn();
        window.addEventListener('keydown', handle_keypress_search );
    }

    // Function that closes the searchform
    function close_search(){
        $('#search-trigger').removeClass('is-open');
        $('#searchform').fadeOut();
        $('#searchresults').delay(500).empty();
        window.removeEventListener( 'keydown', handle_keypress_search );
    }

    // Detects if escape key is pressed to close searchform
    function handle_keypress_search(e){
        if( e.key != "Escape" ){
            return;
        }
        return close_search();
    }


    const searchInput = document.querySelector('.search-field');
    
    if( searchInput ){
        
        let timeout;

        searchInput.addEventListener('input', event => {

            clearTimeout(timeout);
            
            timeout = setTimeout(() => {

                const searchTerm = event.target.value.trim();

                // Require at least 3 characters
                if (searchTerm.length < 3) {
                    document.getElementById('searchresults').innerHTML = '';
                    return;
                }

                fetch(ajaxObj.ajaxurl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: new URLSearchParams({
                        action: 'header_search_form',
                        nonce: ajaxObj.ajaxnonce,
                        search: searchTerm
                    })
                })
                .then( response => response.text() )
                .then( html => document.getElementById('searchresults').innerHTML = html );

            }, 500);

        } )

    }

});